import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import ImageComponent from '../../../components/common/Image';
import Modal, { ModalBody } from '../../../components/common/Modal';
import PropTypes from 'prop-types';


function Header(props) {

  const href = "#";
  const navigate = useNavigate();

  const [showStepModal, setShowStepModal] = useState(false);

  const { userData } = useSelector((state) => state.auth);
  const userType = userData?.response_data?.userType;

  const handleStepModalToggle = () => {
    setShowStepModal(!showStepModal);
  }

  const handleCloseStepModal = () => {
    setShowStepModal(false);
  }

  const handleGoBack = (event) => {
    event.preventDefault();
    navigate('/dashboard');
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      navigate('/dashboard');
    }
  };

  return (
    <>
      <div className="position-relative">
        <header className="sticky-top">
          <div className={"container-fluid topNav application-topnav"}>
            <div className="web-header">
              <div
                className="d-flex flex-wrap align-items-center justify-content-between"
              >
                <div className="d-flex align-items-center tablet-content">
                  <a href={href}>
                    <ImageComponent
                      fileName="cholacd.svg"
                      alt='chola'
                      className="img-fluid tab-logo logo-height" />
                  </a>
                </div>
              </div>
            </div>
            <div className="mob-header">
              <div>
                <div className="text-white d-flex align-items-center justify-content-between">
                  <div className="text-white fs-6 d-flex py-2 mt-2 align-items-center gap-1">
                    <button
                      type="button"
                      className="icon-arrowleftl1 fs-4 btn btn-link text-white p-0 border-0 text-decoration-none"
                      aria-label="Go back to login"
                      onClick={handleGoBack}
                      onKeyDown={handleKeyDown}
                    ></button>
                    {userType === 'dealer' ? 'Basic' : (props?.dealerCode && `Basic` || `Store`)} Details
                  </div>
                  <div>
                    {props?.dealerCode &&
                      <div className="pie-wrapper progress-14 style-2" onClick={handleStepModalToggle}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            handleStepModalToggle();
                          }
                        }}
                        tabIndex={0}
                        role="button"
                        aria-label="View application steps">
                        <span className="label">1/7</span>
                        <div className="pie">
                          <div className="left-side half-circle"></div>
                          <div className="right-side half-circle"></div>
                        </div>
                        <div className="shadow"></div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>

      <Modal
        id="stepRole"
        show={showStepModal}
        onClose={handleCloseStepModal}
        labelledBy="SelectRole"
        modalClass="modal-dialog modal-dialog-centered"
      >
        <ModalBody>
          <div className="stepper-title">
            <div className="d-flex align-items-center justify-content-between stepper-title-text">
              <p className="mb-0">Complete Steps</p>
              <button
                type="button"
                className="btn-close"
                onClick={handleCloseStepModal}
                aria-label="Close"
              ></button>
            </div>
            <p className="mb-0 stepper-title-content">You are few steps away from obtaining your<br/>Consumer Durable loan</p>
          </div>
          <div className="container p-0">
            <div className="steps-vertical">
              <div className="step-vertical active">
                <div className="step-vertical-icon">
                </div>
                <div className="step-vertical-content">
                  <p className="stp">Step 1</p>
                  <h6 className="name">Basic Details</h6>
                  <p className="status">In-progress</p>
                </div>
              </div>
              <div className="step-vertical pending">
                <div className="step-vertical-icon">
                </div>
                <div className="step-vertical-content">
                  <p className="stp">Step 2</p>
                  <h6 className="name">KYC</h6>
                  <p className="status">Pending</p>
                </div>
              </div>
              <div className="step-vertical pending">
                <div className="step-vertical-icon">
                </div>
                <div className="step-vertical-content">
                  <p className="stp">Step 3</p>
                  <h6 className="name">Product Details</h6>
                  <p className="status">Pending</p>
                </div>
              </div>
              <div className="step-vertical pending">
                <div className="step-vertical-icon"></div>
                <div className="step-vertical-content">
                  <p className="stp">Step 4</p>
                  <h6 className="name">Bank Details</h6>
                  <p className="status">Pending</p>
                </div>
              </div>
              <div className="step-vertical pending">
                <div className="step-vertical-icon"></div>
                <div className="step-vertical-content">
                  <p className="stp">Step 5</p>
                  <h6 className="name">Documents</h6>
                  <p className="status">Pending</p>
                </div>
              </div>
              <div className="step-vertical pending">
                <div className="step-vertical-icon"></div>
                <div className="step-vertical-content">
                  <p className="stp">Step 6</p>
                  <h6 className="name">IMEI Validation</h6>
                  <p className="status">Pending</p>
                </div>
              </div>
              <div className="step-vertical pending">
                <div className="step-vertical-icon"></div>
                <div className="step-vertical-content">
                  <p className="stp">Step 7</p>
                  <h6 className="name">Invoice Details</h6>
                  <p className="status">Pending</p>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default Header

Header.propTypes = {
  dealerCode: PropTypes.string, // or PropTypes.number if numeric
  // ... add other props here if needed
};